import Reveal from "@/components/Reveal";
import SectionLabel from "@/components/SectionLabel";
import { PROCESS_STEPS } from "@/data/site";

export default function Process({ index = "/03" }) {
  return (
    <section data-testid="process-section" className="py-24 md:py-32 border-t border-zinc-200 bg-white">
      <div className="container-tight">
        <div className="grid md:grid-cols-12 gap-8 mb-16 items-end">
          <Reveal className="md:col-span-7">
            <SectionLabel index={index} testid="process-label">How we work</SectionLabel>
            <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl text-zinc-900 tracking-tighter leading-[1.02]">
              A five-step process
              <br /><span className="text-zinc-400">that ships on time.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-5">
            <p className="text-zinc-600 leading-relaxed md:text-right">
              Every engagement follows the same disciplined arc — discovery to launch to
              long-term iteration. No surprises, no padded timelines, no black boxes.
            </p>
          </Reveal>
        </div>

        <ol className="relative border-l border-zinc-200">
          {PROCESS_STEPS.map((s, idx) => (
            <Reveal key={s.code} delay={idx * 0.06}>
              <li
                data-testid={`process-step-${s.code}`}
                className="relative pl-8 md:pl-14 py-10 border-b border-zinc-200 last:border-b-0 group"
              >
                <span className="absolute -left-[6px] top-12 w-3 h-3 bg-zinc-900 border border-white shadow-[0_0_0_4px_white] transition-transform group-hover:scale-125" />

                <div className="grid md:grid-cols-12 gap-8 items-start">
                  <div className="md:col-span-3">
                    <p className="font-mono-tech text-xs text-zinc-500 tracking-[0.2em]">
                      STEP {s.code}
                    </p>
                    <h3 className="mt-4 font-display text-3xl md:text-4xl text-zinc-900 tracking-tighter">
                      {s.title}
                    </h3>
                  </div>
                  <div className="md:col-span-6">
                    <p className="text-zinc-700 text-[15px] leading-relaxed">{s.body}</p>
                  </div>
                  <div className="md:col-span-3 md:text-right">
                    <p className="label-mono">Deliverable</p>
                    <p className="mt-3 text-zinc-700 text-sm">{s.deliverable}</p>
                  </div>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
